namespace Entities {

    type Themes = "dark" | "light";
    export class Settings
        implements RavenDocument {
        
        id = Settings.getId();
        theme: Themes = "light";
        printerId?: string;

        static getId()
        {
            return "settings";
        }
    }
}